@if (showLinkedGroup) {
    <!-- TODO: type is completely wrong but yeah somehow it works... -->
    <ms-linked-option-group
        [fixture]="$any(event.winGameLinkedFixture)"
        [parentLinkedEventId]="event.id"
        [groupName]="optionGroup.name"
        [crmPromotedOptionIdsMap]="crmPromotedOptionIdsMap"
        [thresholds]="thresholds" />
} @else {
    <ms-regular-option-group
        [event]="event"
        [optionGroup]="optionGroup"
        [groupType]="groupType"
        [thresholds]="thresholds"
        [tracking]="tracking"
        [trackingModuleType]="trackingModuleType"
        [calendarTrack]="calendarTrack"
        [showMarketHelp]="showMarketHelp"
        [crmPromotedOptionIdsMap]="crmPromotedOptionIdsMap"
        [sourceOfPick]="sourceOfPick"
        [eventHelpText]="eventHelpText"
        [betDetails]="betDetails"
        [optionsLimitOverride]="optionsLimitOverride"
        [showPlayerStats]="showPlayerStats"
        (expandClicked)="onExpandedClicked($event)"
        (showAllRequested)="showAllRequested.next()" />
}
